import { Alert } from "antd";
import { useCallback } from "react";
import { FormattedMessage } from "react-intl";
import { useLocalStorage } from "react-use";

import { useMediaTablet } from "../lib/hooks/basic/media";

const DESKTOP_BANNER_KEY = "desktop-banner-closed";

export function DesktopBanner() {
  const isSmallScreen = useMediaTablet();
  const [closed, setClosed] = useLocalStorage(DESKTOP_BANNER_KEY);
  const setBannerClosed = useCallback(() => setClosed(true), [setClosed]);

  if (!isSmallScreen || closed) return null;

  return (
    <Alert
      closable
      type="info"
      title={
        <FormattedMessage
          id="desktopBanner.title"
          defaultMessage="For the best experience"
        />
      }
      description={
        <FormattedMessage
          id="desktopBanner.description"
          defaultMessage="We recommend using a desktop or laptop computer for the optimal experience. Some features may be limited on mobile devices."
        />
      }
      onClose={setBannerClosed}
    />
  );
}
